export const SLACK_SET_CHANNELS = 'SLACK_SET_CHANNELS'
export const SLACK_SET_IS_SIGNED_IN = 'SLACK_SET_IS_SIGNED_IN'
export const SLACK_SET_USER = 'SLACK_SET_USER'
export const SLACK_SET_USERS = 'SLACK_SET_USERS'
